import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, timer, throwError } from 'rxjs';
import { retry } from 'rxjs/operators';
import { AppInsightsService } from '../app-insights.service';


@Injectable()
export class CustomRetryInterceptor implements HttpInterceptor {
    constructor(private readonly appInsightsService: AppInsightsService) { }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            retry({
                count: 3,    // up to 3 retry attempts
                delay: (error: any, retryCount: number) => {
                    // A timed-out call/SMS may already have succeeded. Retry read requests only.
                    if (
                        error instanceof HttpErrorResponse &&
                        error.status === 504 &&
                        (req.method === 'GET' || req.method === 'HEAD')
                    ) {
                        // Log the 504 error to Application Insights
                        this.appInsightsService.logTrace("504 Gateway Timeout", {
                            url: req.url.split('?')[0],
                            method: req.method,
                            retryAttempt: retryCount,
                            status: 504,
                            statusText: error.statusText
                        });
                        return timer(500);  // wait 500 ms then retry
                    }
                    // otherwise immediately bubble the error
                    return throwError(() => error);
                }
            })
        );
    }
}
